import { useContext, useEffect, useRef } from 'react';
import { useDeviceType } from '~/context/common/DeviceContext';
import ModalContext from '~/context/srp/ModalContext';

export default function useModalScrollRestoration() {
  const { isDesktop } = useDeviceType();
  const { isAnyModalOpen } = useContext(ModalContext);
  const scrollPositionRef = useRef<number>(undefined);

  // .no-scroll class doesn't prevent body scrolling on some mobile devices
  // so we need to manually save and restore scroll position
  useEffect(() => {
    if (isDesktop) return;

    if (isAnyModalOpen) {
      scrollPositionRef.current = window.scrollY;
    } else if (scrollPositionRef.current !== undefined) {
      if (scrollPositionRef.current !== window.scrollY) {
        window.scrollTo({
          top: scrollPositionRef.current,
          behavior: 'instant'
        });
      }
      scrollPositionRef.current = undefined;
    }
  }, [isAnyModalOpen, isDesktop]);
}
